import React, { useState } from "react";
import FullCalendar from "@fullcalendar/react";

import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction"; // needed
import listPlugin from "@fullcalendar/list"; //F
import timeGrid from "@fullcalendar/timegrid";

import moment from "moment";
import AppModal from "../../common/AppModal";
import MarkTaskModel from "./MarkTaskModel";

export default function TaskCalendar({
  tasks = [],
  headerToolbar,
  initialView,
  customButtons,
  innerRef,
}) {
  const [model, setModel] = useState({});
  const MarkTask = MarkTaskModel();
  return (
    <div style={{ padding: 20 }}>
      <FullCalendar
        ref={innerRef}
        visibleRange
        firstDay={1}
        click
        contentHeight={"auto"}
        events={tasks?.map((ts) => {
          const startTime = moment(
            `${moment(ts.date).format("DD/MM/YYYY")}:${ts.startTime}`,
            "DD/MM/YYYY:hh:mma"
          );
          const endTime = moment(
            `${moment(ts.date).format("DD/MM/YYYY")}:${ts.endTime}`,
            "DD/MM/YYYY:hh:mma"
          );
          return {
            id: JSON.stringify(ts),
            date: ts.date,
            title: `${ts.taskId} - ${ts.organization?.name || "N/A"} - ${
              Array.isArray(ts.employee)
                ? ts.employee.map((i) => i?.name || "N/A").join(", ")
                : ts.employee?.name || "N/A"
            }`,
            display: true,
            start: new Date(startTime),
            end: new Date(endTime),
            overlap: true,
            durationEditable: true,
            color:
              ["Done", "Completed"].includes(ts.status)
                ? "#4BB543"
                : ts.status === "Not Completed"
                ? "tomato"
                : ts.status === "InProgress"
                ? "orange"
                : ts.status === "Expired"
                ? "gray"
                : "dodgerblue",
          };
        })}
        eventClick={(event) => {
          const task = JSON.parse(event.event.id);
          setModel({
            body: <MarkTask.Body task={task} />,
            header: (
              <MarkTask.Header
                task={task}
                setModel={setModel}
                onDone={() => {
                  setModel({});
                }}
              />
            ),
            visible: true,
          });
        }}
        plugins={[dayGridPlugin, interactionPlugin, listPlugin, timeGrid]}
        initialView={initialView || "listWeek"}
        headerToolbar={
          headerToolbar || {
            left: "prev,next,today",
            center: "title",
            right: "dayGridMonth,listWeek",
          }
        }
        customButtons={customButtons}
      />
      <AppModal
        onHide={() => {
          setModel({});
        }}
        {...model}
        bodyStyle={{ overflowY: "unset" }}
      />
    </div>
  );
}
